import { ShieldCheckIcon } from "lucide-react";
import { useState } from "react";

import { errorMessage } from "@/api/client";
import { useAcceptTerms, useLogout } from "@/api/hooks/auth";
import { FormAlert } from "@/components/common/form-alert";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { TermsCheckbox } from "@/components/common/terms-checkbox";

/**
 * Blocking: the account hasn't accepted the current Terms and Privacy Policy (new version, or an
 * account made by single sign-on). Nothing else works until it does; signing out is the way out.
 */
export function TermsDialog() {
  const [checked, setChecked] = useState(false);
  const accept = useAcceptTerms();
  const logout = useLogout();
  return (
    <Dialog open>
      <DialogContent
        showCloseButton={false}
        onEscapeKeyDown={(event) => event.preventDefault()}
        onPointerDownOutside={(event) => event.preventDefault()}
        onInteractOutside={(event) => event.preventDefault()}
      >
        <DialogHeader>
          <div className="mb-1 flex size-10 items-center justify-center rounded-full bg-accent text-accent-foreground">
            <ShieldCheckIcon className="size-5" aria-hidden />
          </div>
          <DialogTitle>Before you continue</DialogTitle>
          <DialogDescription>
            Your organization uses this site to train and assess its people. It records what you do here, including the
            network address you sign in and work from, as the Privacy Policy explains.
          </DialogDescription>
        </DialogHeader>
        <FormAlert message={accept.error ? errorMessage(accept.error) : null} />
        <TermsCheckbox checked={checked} onCheckedChange={setChecked} />
        <DialogFooter>
          <Button variant="ghost" onClick={() => logout.mutate()} disabled={logout.isPending}>
            Sign out
          </Button>
          <Button onClick={() => accept.mutate()} disabled={!checked || accept.isPending}>
            Accept and continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
